import React from 'react'
import styled from 'styled-components'
// import ScrollAnimation from 'react-animate-on-scroll'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { verticalPadding } from 'styles/global'

import Section from 'components/Section'
import Wrapper from 'components/Wrapper'
import Item, { Color, Preview, Plus } from './Item'

const Container = styled.div`
  background-color: #0e0e0e;
`

const Inner = styled.div`
  overflow: hidden;
  margin-left: -${spacing.large};
  margin-right: -${spacing.large};

  ${media.small`
    margin-left: -${spacing.xxLarge};
    margin-right: -${spacing.xxLarge};
  `};

  ${media.medium`
    margin-left: -${spacing.xxLarge};
    margin-right: -${spacing.xxxLarge};
  `};

  ${media.large`
    margin: 0;
  `};
`

const List = styled.div`
  display: block;
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  ${verticalPadding`2.5rem`};

  ${media.small`
    ${verticalPadding`3.25rem`};
  `};

  ${media.medium`
    ${verticalPadding`4rem`};
  `};

  ${media.large`
    display: flex;
    overflow: hidden; /* No scrolling */
    ${verticalPadding`4.5rem`};
  `};
`

const Slide = styled.div`
  display: inline-block;
  margin-right: ${spacing.xLarge};
  width: 130px;

  &:first-child {
    margin-left: ${spacing.large};
  }

  ${media.small`
    width: 160px;

    &:first-child {
      margin-left: ${spacing.xxLarge};
    }

    &:last-child {
      margin-right: ${spacing.xxLarge};
    }
  `};

  ${media.medium`
    width: 210px;

    &:first-child {
      margin-left: ${spacing.xxxLarge};
    }
    
    &:last-child {
      margin-right: ${spacing.xxxLarge};
    }
  `};

  ${media.large`
    width: auto;
    flex: 1;

    &:first-child {
      margin-left: 0;
    }
    
    &:last-child {
      margin-right: 0;
    }
  `};

  ${media.xLarge`
    margin-right: ${spacing.xxLarge};
  `};
`

const Products = () => (
  <Container>
    <Section flushTop flushBottom>
      <Wrapper>
        <div>
          {/* <ScrollAnimation animateIn="fadeInUp" offset={0} delay={0} animateOnce> */}
          <Inner>
            <List>
              <Slide>
                <Item
                  link="/buy-online/vype-epod-vpro-cartridges/"
                  name="Pods"
                  figure="pods"
                  footer={
                    <>
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/watermelon.png`} />
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/cool-peppermint.png`} />
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/lemon-berry.png`} />
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/tobacco.png`} />
                      <Plus>+18</Plus>
                    </>
                  }
                />
              </Slide>
              <Slide>
                <Item
                  link="/buy-online/vype-epod-skins/"
                  name="Skins"
                  figure="skins"
                  footer={
                    <>
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/express.png`} isCircle />
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/maze.png`} isCircle />
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/crystal.png`} isCircle />
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/linear.png`} isCircle />
                      <Plus>+2</Plus>
                    </>
                  }
                />
              </Slide>
              <Slide>
                <Item
                  link="/buy-online/engravable/"
                  name="Engraving"
                  figure="engraving"
                  footer={
                    <>
                      <Color color="linear-gradient(90deg, #000000 12.5%, #3A3A3A 95.83%)" />
                      <Color color="linear-gradient(90deg, #4D4D4D 12.5%, #989898 95.83%)" />
                      <Color color="linear-gradient(90deg, #746B5C 12.5%, #D6BE9C 95.83%)" />
                      <Color color="linear-gradient(90deg, #625251 12.5%, #E7B8B0 95.83%)" />
                      <Color color="linear-gradient(90deg, #61666F 12.5%, #D4D7DF 95.83%)" />
                    </>
                  }
                />
              </Slide>
              <Slide>
                <Item
                  name="Charging cases"
                  figure="cases"
                  footer={
                    <>
                      <Plus>Coming soon</Plus>
                    </>
                  }
                />
              </Slide>
              <Slide>
                <Item
                  link="/buy-online/vype-epod-accessories/"
                  name="All Accessories"
                  figure="accessories"
                  footer={
                    <>
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/case.png`} />
                      <Preview src={`${process.env.BASE_PATH}/images/epod2/preview/cap.png`} />
                    </>
                  }
                />
              </Slide>
            </List>
          </Inner>
          {/* </ScrollAnimation> */}
        </div>
      </Wrapper>
    </Section>
  </Container>
)

export default Products
